import { create } from 'zustand';

/** Sidebar UI state: controls which panel is open */
interface SidebarState {
  /** Currently open panel ID, or null when only the icon rail is visible */
  activePanel: string | null;

  /** Set the active panel directly (null to close) */
  setActivePanel: (id: string | null) => void;

  /** Toggle a panel: clicking the same icon closes it, otherwise opens the new panel */
  togglePanel: (id: string) => void;
}

/** Store for sidebar panel state */
export const useSidebarStore = create<SidebarState>((set) => ({
  activePanel: null,
  setActivePanel: (id) => set({ activePanel: id }),
  togglePanel: (id) =>
    set((state) => ({ activePanel: state.activePanel === id ? null : id })),
}));
